export enum PositionTypes {
  NEXT = 'next',
  PREV = 'prev',
}

export function getNextOrPrevItem(array, currentUuid, operator) {
  const curentItemIndex = array.findIndex(item => item.uuid === currentUuid);
  const index = operator === PositionTypes.NEXT ? curentItemIndex + 1 : curentItemIndex - 1;
  const item = array[index];
  const uuid = item ? item.uuid : array[curentItemIndex].uuid;
  return uuid;
}
